import React from 'react'

const NotVerified = () => {
    return (
        <div className="flex flex-col justify-center items-center my-20">
            <div className="bg-white rounded-xl flex flex-col gap-4 justify-center items-center py-10 px-10">
                <div className="bg-gray-200 rounded-full p-8">
                    <img src="../Assets/Prop/Lock.png" alt="" className='w-16' />
                </div>
                <p className='font-pop text-gray-400 text-center max-w-md'>While your documents are being reviewed, you cannot see or use the app features</p>
            </div>
        </div>
    )
}

export default NotVerified